// extracted by mini-css-extract-plugin
export var border = "_f-7";
export var brand = "_f-r";
export var button = "_f-j";
export var center = "_f-9";
export var centered = "_f-5";
export var closeButton = "_f-b";
export var disabledWrapper = "_f-k";
export var error = "_f-n";
export var extraLarge = "_f-4";
export var extraSmall = "_f-1";
export var fill = "_f-g";
export var footer = "_f-f";
export var footerAction = "_f-h";
export var footerButtons = "_f-i";
export var header = "_f-6";
export var icon = "_f-m";
export var info = "_f-q";
export var inline = "_f-8";
export var large = "_f-3";
export var main = "_f-c";
export var modal = "_f-0";
export var neutral = "_f-s";
export var noPadding = "_f-e";
export var none = "_f-t";
export var scrollable = "_f-d";
export var small = "_f-2";
export var success = "_f-p";
export var tight = "_f-l";
export var titleIcon = "_f-a";
export var warn = "_f-o";